import React from 'react';
import { Row, Col, Switch } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';
import FormField from '../../shared/FormField';
import SelectField from '../../shared/SelectField';
import { useFormStore } from '../../../store/formStore';
import { MODALIDADES_COMPENSACAO } from '@engenharia/shared';

const TIPO_SOLICITACAO_OPTIONS = [
  { label: 'Venda Concluída', value: 'VendaConcluida' },
  { label: 'Homologação Prévia', value: 'HomologacaoPrevia' },
];

const TIPO_ESTRUTURA_OPTIONS = [
  { label: 'Metálico', value: 'Metalico' },
  { label: 'Cerâmico', value: 'Ceramico' },
  { label: 'Solo', value: 'Solo' },
  { label: 'Carport', value: 'Carport' },
  { label: 'Fibrocimento', value: 'Fibrocimento' },
  { label: 'Fibromadeira', value: 'Fibromadeira' },
  { label: 'Laje', value: 'Laje' },
];

const TIPO_LOCALIZACAO_OPTIONS = [
  { label: 'Urbana', value: 'urbana' },
  { label: 'Rural', value: 'rural' },
];

export default function ProjetoInfoSection() {
  const { watch, control } = useFormContext();
  const concessionarias = useFormStore((s) => s.concessionarias);

  const ampliacao = watch('ampliacao_usina');
  const modalidade = watch('modalidade_compensacao');
  const localizacao = watch('tipo_localizacao');

  const concOptions = concessionarias.map((c) => ({ label: c.nome, value: c.id }));
  const modalidadeOptions = MODALIDADES_COMPENSACAO.map((m) => ({ label: m, value: m }));

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-4">Informações do Projeto</h3>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SelectField name="tipo_solicitacao" label="Tipo de Solicitação" options={TIPO_SOLICITACAO_OPTIONS} required />
        </Col>
        <Col xs={24} sm={12}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Ampliação de Usina</label>
            <Controller
              name="ampliacao_usina"
              control={control}
              render={({ field }) => (
                <Switch checked={field.value} onChange={field.onChange} />
              )}
            />
          </div>
        </Col>
      </Row>

      {ampliacao && (
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <FormField name="potencia_existente_kw" label="Potência Existente (kW)" type="number" />
          </Col>
          <Col xs={24} sm={12}>
            <FormField name="descricao_usina_existente" label="Descrição da Usina Existente" textarea />
          </Col>
        </Row>
      )}

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <FormField name="potencia_adquirida_kwp" label="Potência Adquirida (kWp)" type="number" required />
        </Col>
        <Col xs={24} sm={8}>
          <SelectField name="tipo_estrutura" label="Tipo de Estrutura" options={TIPO_ESTRUTURA_OPTIONS} required />
        </Col>
        <Col xs={24} sm={8}>
          <SelectField name="concessionaria_id" label="Concessionária" options={concOptions} required />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SelectField name="modalidade_compensacao" label="Modalidade de Compensação" options={modalidadeOptions} required />
        </Col>
        {modalidade && modalidade !== 'Autoconsumo Local' && (
          <Col xs={24} sm={12}>
            <FormField name="tipo_compensacao" label="Tipo de Compensação" />
          </Col>
        )}
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SelectField name="tipo_localizacao" label="Localização" options={TIPO_LOCALIZACAO_OPTIONS} required />
        </Col>
        {localizacao === 'rural' && (
          <Col xs={24} sm={12}>
            <FormField name="coordenadas_transformador" label="Coordenadas do Transformador" />
          </Col>
        )}
      </Row>
    </div>
  );
}
